(function($, B) {
    'use strict';
    B.web.toInit['gotop'] = true;
    B.web.widgets['gotop'] = {
        enabled: false,
        selectors: {
            btn: '[data-gotop]'
        },
        $elements:{
        },
        data:{           
        },
        init:function(){
            var that = this;
            Bajt.web.getElements(this.selectors, this.$elements);

        }

    };

})(jQuery, Bajt);